import React, { useState } from 'react';
import Swal from 'sweetalert2';
import SourceDatabaseService from '../../services/SourceDatabaseService'; // Import the service for source databases
import { useNavigate } from 'react-router-dom';

const SourceDatabaseCreate = () => {
  const [formData, setFormData] = useState({
    host: '',
    port: '3306', // Default port for MySQL
    database_name: '',
    username: '',
    password: '',
  });
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await SourceDatabaseService.add(formData);
      Swal.fire('Created!', 'Source Database created successfully.', 'success');
      navigate('/source-databases'); // Redirect to the source databases list
    } catch (error) {
      console.error('Error creating source database:', error);
      Swal.fire('Error!', 'An error occurred while creating the source database.', 'error');
    }
  };

  // Handle cancel action
  const handleCancel = () => {
    navigate('/source-databases'); // Redirect to the source databases list
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Create Source Database</h4>
              <p className="card-description">Add a new source database</p>
              
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="host">Host</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="host"
                    name="host"
                    value={formData.host}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="port">Port</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="port"
                    name="port"
                    value={formData.port}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="database_name">Database Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="database_name"
                    name="database_name"
                    value={formData.database_name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="username"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control form-control-sm"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-sm mr-2">Create</button>
                <button type="button" className="btn btn-light btn-sm" onClick={handleCancel}>Cancel</button>
              </form>
            </div>
            <div className="card-footer text-muted">
              Please fill out all fields to add a new source database.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceDatabaseCreate;
